import useTypedSWR from 'src/components/general/useTypedSWR';
import { GET_PRESCRIPTION_TASK_QUERY } from 'src/prescriptionTasksQueue/hooks/usePrescriptionTask.gql';

export const usePrescriptionTask = (eventId: string) => {
  const { data, error, mutate } = useTypedSWR([GET_PRESCRIPTION_TASK_QUERY, { eventId }]);

  return {
    data: data?.staff_getPrescriptionTaskForEvent ?? null,
    isLoading: !data && !error,
    error,
    mutate,
  };
};
